export default "__VITE_ASSET__CElrktEl__"